import Vue from 'vue';
import i18n from '@/i18n/index';

const EventBus = new Vue({
  i18n,
  methods:{
    loadingPage(loading){
      EventBus.$emit('LOADING_PAGE', loading);
    },
    loadingModal(loading){
      EventBus.$emit('LOADING_MODAL', loading);
    },
    logout(){
      EventBus.$emit('LOGOUT');
    }
  }
});

export default EventBus;
